$(function() {

    var announcement_bar = Cookies.get('announcement');

    if(announcement_bar == undefined) {

        // console.log('SHOW announcment bar');
        var header_offset = $('.sa-bar').height();
        console.log("Header offset: ",header_offset);
        $('.sab-active').css('top', header_offset + 'px');
        $('.j-spacer').css('padding-top', header_offset + 'px');
        $('.sa-bar').removeClass('remove');
  
        

    } else {

        // console.log('HIDE announcment bar');
       // $('.j-close-sab').parent().addClass('remove');
       // $('.site-header').css('top', '0px');
      //  $('.j-spacer').css('padding-top', '0px');

    }

    if($('.announcement-content p').length > 1){
        $('.j-announcment-bar-carousel').slick({
            autoplay:true,
            autoplaySpeed:2000,
            infinite:true,
            arrows:false,
            dots:false,
            swipeToSlide:true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll:1,
            // responsive: [
            //     {
            //         breakpoint: 1200,
            //         settings: "unslick"
            //     }
            // ]			
        });
    }
        
    $(window).on('resize', function() {
        $('.j-announcment-bar-carousel').slick('resize');
    });
    

});

$(document).on('click', '.j-close-sab', function(e){

    e.preventDefault();
    $(this).parent().addClass('remove');
    $('.sab-active').css('top', '0px');
    $('body').css('padding-top', '0px');
    Cookies.set('announcement', 'true', { expires: 365 });


});